import genPayment from './gen-payment'
import listInvoices from './list-invoices'
import invoicesHistory from './invoices-history'
import topup from './topup'
import fetchDiskHdd from './fetch-disk-hdd'
import fetchDiskSsd from './fetch-disk-ssd'
import fetchSnapshotHdd from './fetch-snapshot-hdd'
import fetchSnapshotSsd from './fetch-snapshot-ssd'
import fetchCpu from './fetch-cpu'
import fetchRam from './fetch-ram'
import fetchWanIP from './fetch-wanip'
import applyCouponCode from './apply-coupon-code'
import payInvoice from './pay-an-invoice'
import payOrder from './pay-an-order'
import cancelOrder from './cancel-an-order'
import checkCouponCode from './checkCouponCode'
import createOrder from './create-order'
import fetchOrder from './fetch-orders'
import fetchPayments from './fetch-payments'
import fetchExtra from './fetch-extra'
import fetchIp from './fetch-ip'
import getPrice from './get-price'
import getPriceCoupon from './get-price-coupon'
import fetchPackage from './fetch-package'
import fetchPackages from './fetch-packages'

export default {
  genPayment,
  listInvoices,
  invoicesHistory,
  topup,
  fetchDiskHdd,
  fetchDiskSsd,
  fetchSnapshotHdd,
  fetchSnapshotSsd,
  fetchCpu,
  fetchRam,
  fetchWanIP,
  applyCouponCode,
  payInvoice,
  payOrder,
  cancelOrder,
  checkCouponCode,
  createOrder,
  fetchOrder,
  fetchPayments,
  fetchExtra,
  fetchIp,
  getPrice,
  getPriceCoupon,
  fetchPackage,
  fetchPackages
}



// WEBPACK FOOTER //
// ./src/services/billing/index.js